import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { mockApiServices } from 'app/mock-api';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { environment } from 'environments/environment';
// import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTableModule } from '@angular/material/table';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { InternalComponent } from './modules/bus/internal/internal.component'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { FuseAlertModule } from '@fuse/components/alert';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule, MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
// import { SearchFilterPipe } from './providers/search-filter.pipe';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
 




import { HelpDocsModule } from './modules/help-docs/help-docs.module';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { CommonModule } from '@angular/common';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { FuseCardModule } from '@fuse/components/card';
import { FuseDrawerModule } from '@fuse/components/drawer';
import { FuseHighlightModule } from '@fuse/components/highlight';
import { FuseNavigationModule } from '@fuse/components/navigation';
import { FuseScrollResetModule } from '@fuse/directives/scroll-reset';
import { FuseScrollbarModule } from '@fuse/directives/scrollbar';
import { FuseFindByKeyPipeModule } from '@fuse/pipes/find-by-key';
import { DevExtremeModule, DxSelectBoxModule } from 'devextreme-angular';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { SetupCommonModule } from './modules/gen/setup/common/setup-common.module';
import { LoadingModule } from './shared/loading/loading/loading.module';
import { SharedModule } from './shared/shared.module';
import { CstmNotificationBarComponent } from './shared/cstm-notification-bar/cstm-notification-bar.component';
import { CustomDialougeBox } from './shared/dailog_box/custom_dialog';
import { RoutePermissionGuards } from './modules/gen/setup/routepermissionguards';
import { StarRatingModule } from 'angular-star-rating';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { DlrHelpDocsComponent } from './apps/dlr-monitor/dlr-help-docs/dlr-help-docs.component';
// import { RegistryHeaderModule } from './apps/registers/registry-header/registry-header.module';
// import { RegistryComponent } from './apps/registers/registry/registry.component';

// import { TcktDtlsComponent } from './modules/gen/tckt-dtls/tckt-dtls.component';
// import { TcktLstComponent } from './modules/gen/tckt-lst/tckt-lst.component';
// import { authguardGuard, AuthGuards } from './modules/gen/setup/authguard.guard';
// import { ThemeConstantService } from './shared/services/theme-constant.service';
// import { HomeDashboardComponent } from './modules/cpy/home-dashboard/home-dashboard.component';

const routerConfig: ExtraOptions = {
    scrollPositionRestoration: 'enabled',
    preloadingStrategy: PreloadAllModules
};
// const SocketConfig: SocketIoConfig = { url: environment.apiOrigin
// //     , options: {
// //     withCredentials: true,
// //   } 
// };

@NgModule({
    declarations: [
        AppComponent,
        InternalComponent,
        CstmNotificationBarComponent,
        CustomDialougeBox,
        // RegistryComponent
        // TcktDtlsComponent,
        // TcktLstComponent
      
    ],

    imports: [
        BrowserModule,
        // RegistryHeaderModule,
        FormsModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),
        
        
        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),

        // Core module of your application
        CoreModule,


        HelpDocsModule,
        // Layout module of your application
        LayoutModule,

        // 3rd party modules that require global configuration via forRoot
        MarkdownModule.forRoot({}),
        // NgxQRCodeModule,
        MatDialogModule,
        MatSnackBarModule, MatGridListModule,
        MatSidenavModule,
        MatTableModule,
        NgIdleKeepaliveModule.forRoot(),
        FuseAlertModule, MatToolbarModule, MatChipsModule, MatDividerModule,
        MatTabsModule, MatCardModule, MatInputModule, MatFormFieldModule, MatSelectModule, MatOptionModule, MatDatepickerModule, MatAutocompleteModule,
        MatTableModule, MatPaginatorModule, MatSortModule, MatIconModule, MatButtonModule, MatTooltipModule, MatSlideToggleModule,
        MatGridListModule, MatProgressSpinnerModule, MatListModule, MatCheckboxModule, NgxMatSelectSearchModule,

        MatRadioModule,
        FuseHighlightModule,
        SetupCommonModule,
        MatRippleModule,
        CommonModule,
        FuseFindByKeyPipeModule,
        FuseNavigationModule,
        FuseScrollbarModule,
        FuseCardModule,
        FuseScrollResetModule,
        ReactiveFormsModule,
        MatButtonToggleModule,
        MatMenuModule,
        MatProgressBarModule,
        MatNativeDateModule,
        SharedModule,
        BaseChartDirective,
        DevExtremeModule,
        LoadingModule,
        FuseDrawerModule,
        NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule, NgxMatMomentModule, DxSelectBoxModule,
        StarRatingModule.forRoot(),
        DlrHelpDocsComponent
    ],
    providers: [RoutePermissionGuards,provideCharts(withDefaultRegisterables())],

    bootstrap: [
        AppComponent
    ],
    exports : [
        CstmNotificationBarComponent,
        CustomDialougeBox
    ]
    // providers:[
    //     ThemeConstantService,
    // ]
})
export class AppModule {
}
